export const dateToLocalDate = (date: Date = new Date()): string => {
  const offset = date.getTimezoneOffset()
  const adjusted = new Date(date.getTime() - offset * 60 * 1000)
  return adjusted.toISOString().split('T')[0]
}
